import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const DebtsPage = lazy(async () => {
  const m = await import("@/features/debts/components/debts-page");
  return { default: m.DebtsPage };
});

function DebtsPageWrapper() {
  return (
    <Suspense fallback={null}>
      <DebtsPage />
    </Suspense>
  );
}

interface DebtsSearch {
  /** Expanded card (payment history): `?open=<debtId>`. */
  open?: string;
  /** Create debt with preselected direction: `?new=owed_to_me|i_owe`. */
  new?: "owed_to_me" | "i_owe";
  /** Edit debt: `?edit=<debtId>`. */
  edit?: string;
  /** Add payment to a debt: `?pay=<debtId>`. */
  pay?: string;
}

function asString(value: unknown): string | undefined {
  return typeof value === "string" && value.length > 0 ? value : undefined;
}

/** validateSearch: expansion + create/edit/payment dialogs live in the URL. */
function sanitizeDebtsSearch(search: Record<string, unknown>): DebtsSearch {
  const dir = search.new;
  return {
    open: asString(search.open),
    new: dir === "owed_to_me" || dir === "i_owe" ? dir : undefined,
    edit: asString(search.edit),
    pay: asString(search.pay),
  };
}

export const debtsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/debts",
  validateSearch: sanitizeDebtsSearch,
  component: DebtsPageWrapper,
});
